import React, { useContext, useEffect, useState } from "react";
import Overlay from "../../../Componentes/Overlay"
import Modal from "../../../Componentes/Utils/Modal"
import SmallLoading from "../../../Componentes/Utils/SmallLoading";
import Tabela from "../../../Componentes/Utils/Tabela";
import axios from "axios";
import styled from "styled-components";

import { FaTrashAlt } from "react-icons/fa";
import { MdModeEditOutline } from "react-icons/md";
import { FiPlusCircle } from "react-icons/fi";
import ModalAddConteudo from "./ModalAddConteudo";
import { useModal } from "../../../contexts/ModalContext";
import ModalDeleteConteudo from "./ModalDeleteConteudo";
import { VerifyPermission } from "../../../Funcoes/VerifyPermission";
import { AuthContext } from "../../../Auth/AuthProvider";

const LinhaPadrao = styled.tr`
    color: black;
`

const LinhaAcao = styled.tr`
    color: black;
    background-color: rgba( 0, 128, 0, 0.6 ) !important;
    td{
        text-align: center !important;
    }
    transition: .3s;
    &:hover{
        background-color: rgba( 0, 128, 0, 0.9 ) !important;
    }
`

const ColunaAcoes = styled.td`
    width: 150px;
    flex-shrink: 0;
`

const ContainerAcoes = styled.div`
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-shrink: 0;
`

const IconEdit = styled(MdModeEditOutline)`
    color: blue;
    width: 25px;
    height: 25px;
`

const IconAdd = styled(FiPlusCircle)`
    color: green;
    width: 23px;
    height: 23px;
`

const IconDelete = styled(FaTrashAlt)`
    color: red;
    width: 23px;
    height: 23px;
`

const ModalConteudo = ({ funcao, onClose }) => {

    const { user } = useContext(AuthContext)
    const { openModal, closeModal, isModalOpen } = useModal();

    const [modalData, setModalData] = useState({
        modo: null,
        item: null,
        idParent: null
    })

    const [loading, setLoading] = useState(true);
    const [dados, setDados] = useState([]);

    const fetchData = async () => {

        setLoading(true);

        try {

            const formData = new FormData();
            formData.append("funcao", funcao);

            const { data } = await axios.post("https://sistemaintegrado.palmont.com.br/Painel/API/Treinamentos/GetConteudoOs/", formData, { withCredentials: true });
            console.log(data)

            setDados(data)

        } catch (e) {

            console.log(e)

        } finally {

            setLoading(false)

        }

    }

    useEffect(() => {

        fetchData();

    }, [])

    const renderizarLinhas = (itens, nivel = 0) => {

        return (itens.map((item) => (
            <React.Fragment key={item.identifier} >
                <LinhaPadrao>
                    <td style={{ paddingLeft: `${nivel * 10 + 10}px` }} >{item.numero} - {item.conteudo}</td>
                    <ColunaAcoes>
                        {
                            VerifyPermission(user, { modulo: 'ssma', submodulo: 'treinamentos', funcao: 'editar_catalogo' }) && (
                                <ContainerAcoes>
                                    <IconEdit
                                        onClick={() => openConteudo({ modo: "edit", item: item })}
                                    />
                                    <IconAdd
                                        onClick={() => openConteudo({ modo: "add", item: item, idParent: item.identifier })}
                                    />
                                    <IconDelete
                                        onClick={() => openDelete(item.id)}
                                    />
                                </ContainerAcoes>
                            )
                        }
                    </ColunaAcoes>
                </LinhaPadrao>
                {item.filhos && item.filhos.length > 0 && renderizarLinhas(item.filhos, nivel + 1)}
            </React.Fragment>
        )))

    }

    const openConteudo = ({ modo = "add", item = null, idParent }) => {

        console.log(item)
        console.log(idParent)

        setModalData({ modo, item, idParent })
        openModal("addConteudoOs")

    }

    const [deleteId, setDeleteId] = useState(null)

    const openDelete = (id) => {

        setDeleteId(id)
        openModal("deleteConteudoOs")

    }

    const closeDelete = () => {

        setDeleteId(null);
        closeModal();

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header={true} size="xl" close={onClose} >
                    {
                        loading ? (
                            <SmallLoading />
                        ) : (
                            <Tabela>
                                <thead>
                                    <tr>
                                        <th colSpan={2} > CONTEÚDO DA O.S. {funcao} </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {renderizarLinhas(dados)}
                                    {
                                        VerifyPermission(user, { modulo: 'ssma', submodulo: 'treinamentos', funcao: 'editar_catalogo' }) && (
                                            <LinhaAcao onClick={() => openConteudo({ modo: "add" })} >
                                                <td colSpan={2} >
                                                    ADICIONAR CONTEÚDO
                                                </td>
                                            </LinhaAcao>
                                        )
                                    }
                                </tbody>
                            </Tabela>
                        )
                    }
                </Modal>
            </Overlay>
            {
                isModalOpen("addConteudoOs") && (
                    <ModalAddConteudo
                        modo={modalData.modo}
                        item={modalData.item}
                        idParent={modalData.idParent}
                        funcao={funcao}
                        close={closeModal}
                        onSuccess={fetchData}
                    />
                )
            }
            {
                isModalOpen("deleteConteudoOs") && (
                    <ModalDeleteConteudo
                        id={deleteId}
                        onClose={closeDelete}
                        onSuccess={fetchData}
                    />
                )
            }
        </>
    )

}

export default ModalConteudo;